import { render, staticRenderFns } from "./BirthdayLists.vue?vue&type=template&id=3c9cd5e8&"
import script from "./BirthdayLists.vue?vue&type=script&lang=js&"
export * from "./BirthdayLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports